import React, { useState, useEffect, useRef } from "react";
import Typography from "../components/Typography";
import { borderRadius, spacing } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";
import { useQueue } from "../context/QueueContext";

import { Clock, ArrowUp, ArrowDown } from "@phosphor-icons/react";
import MarketStatus from "./MarketStatus";
import { hover } from "framer-motion";


function TickerPrice({
    prices, hoverData
}){
    const { theme } = useTheme(); 
    const [currentTime, setCurrentTime] = useState('');

    const isHoverActive = hoverData !== null && hoverData.timestamp !== "";

    console.log(isHoverActive)
    console.log(prices)
    console.log(hoverData)

    const formattedChangePerc = isHoverActive ? hoverData.percentageChange.toFixed(2) : Math.abs(prices.todaysChangePerc)?.toFixed(2);
    const formattedChange = isHoverActive ? hoverData.priceChange.toFixed(2) : Math.abs(prices.todaysChange)?.toFixed(2);
    const formattedCurrentPrice = isHoverActive ? hoverData.price.toFixed(2) : prices.day.c.toFixed(2);

    const isPositive = prices.todaysChange >= 0;
    const ChangeIcon = isPositive ? ArrowUp : ArrowDown;
    const changeColor = isPositive ? theme.colors.positiveFillPrimary : theme.colors.negativeFillPrimary
    const changeBackground = isPositive ? theme.colors.positiveFillSecondary : theme.colors.negativeFillSecondary

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            const options = { 
                year: 'numeric', month: 'short', day: '2-digit', 
                hour: '2-digit', minute: '2-digit', 
                timeZoneName: 'short' 
            };
            if(!isHoverActive) {
              setCurrentTime(new Intl.DateTimeFormat('en-US', options).format(now));
            } else {
              setCurrentTime(new Intl.DateTimeFormat('en-US', options).format(hoverData.timestamp))
            }
        };

        updateTime(); // Update immediately on mount
        const interval = setInterval(updateTime, 5 * 60 * 1000); // Update every 5 minutes

        return () => clearInterval(interval); // Cleanup on unmount
    }, [hoverData]);



    const styles = {
          container:{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            height: "fit-content",
            gap: `${spacing.m}px`,
            backgroundColor: theme.colors.fillPrimary,
            color: theme.colors.contentPrimary,
            padding: `${spacing.xs}px ${spacing.m}px ${spacing.m}px ${spacing.m}px`,
            boxSizing: "border-box",
          },
          priceContainer:{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            height: "fit-content",
            gap: `${spacing.s}px`,
          },
          priceGroup:{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: `${spacing.s}px`,
          },
          currentPriceContainer:{
            display: "flex",
            gap: `${spacing.s}px`,
          },
          currentPrice:{
            fontSize: "36px",
            fontWeight: "700",
          },
          priceChangeContainer:{
            display: "flex",
            gap: `${spacing.s}px`,
          },
          priceChangeChip:{
            display: "flex",
            gap: `${spacing.xs}px`,
            alignItems: "center",
            color: changeColor,
            background: changeBackground,
            borderRadius: borderRadius.s,
            padding: `${spacing.xs}px ${spacing.s}px`,
          },
          timeStampContainer:{
            display: "flex",
            gap: `${spacing.xs}px`,
            alignItems: "center",
            color: theme.colors.contentSecondary,
          }
    
      };
    
    return (
        <div style={styles.container}>

            <MarketStatus />

            <div style={styles.priceContainer}>
                <div style={styles.priceGroup}>
                    <div style={styles.currentPriceContainer}>
                        <Typography variant="headlineMedia" type="editorial" style={styles.currentPrice}>{formattedCurrentPrice}</Typography>
                        <Typography variant="supportingCaption" type="editorial" style={{color: theme.colors.contentSecondary}}>USD</Typography>
                    </div>
                    <div style={styles.priceChangeContainer}>
                        <div style={styles.priceChangeChip}>
                            <ChangeIcon size={12} />
                            <Typography variant="supportingCaption" type="editorial">{formattedChangePerc}%</Typography>
                        </div>
                        <div style={styles.priceChangeChip}>
                            <ChangeIcon size={12} />
                            <Typography variant="supportingCaption" type="editorial">{formattedChange}</Typography>
                        </div>
                    </div>
                </div>

                <div style={styles.timeStampContainer}>
                        <Clock size={13} />
                        <Typography variant="label" type="utility">As of {currentTime}</Typography>
                </div>
            
            </div>
            
        </div>
    )
}

export default TickerPrice;